import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { IosSafeRegion } from '@src/js/common/constants/safe-region';
import { isPortrait } from '@src/js/common/utils';

const DEFAULT_BOTTOM = 0;
const DEFAULT_SAFARI_BOTTOM = (browser.isIPad && !browser.isIPadPro) ? 62 : 93;

/**
 * 获取ios需要在底部增加安全区的距离
 */
export const getIosSafeBottom = (): number => {
    const safariBottom = getSafariBottom();
    // 当计算得出的safariBottom不为0时，已包含安全区的高度，直接返回safariBottom即可。
    if (safariBottom) {
        return safariBottom;
    }
    let safeBottom = DEFAULT_BOTTOM;
    if (browser.isIPadPro) {
        safeBottom = IosSafeRegion.SAFE_REGION_IPAD_PRO;
    } else if (browser.checkIsLargeThanIphoneX) {
        if (isPortrait()) {
            safeBottom = IosSafeRegion.SAFE_REGION_IPHONEX;
        } else {
            safeBottom = IosSafeRegion.SAFE_REGION_IPHONEX_NOPORTRIT;
        }
    }
    safeBottom += getExtraBottom();
    return safeBottom;
};

export const getExtraBottom = () => {
    const size100vh = document.getElementById('place100wh')?.clientHeight || document.body.clientHeight;
    return size100vh - document.body.clientHeight;
};

/**
 * 返回safari浏览器底部工具栏的bottom
 */
export const getSafariBottom = (): number => {
    if (!browser.isSafari) return DEFAULT_BOTTOM;
    let bottom = DEFAULT_BOTTOM;
    if (browser.isIPad || !isPortrait()) {
        // 横屏或者ipad的导航栏不会移动，所以取默认值
        bottom = DEFAULT_SAFARI_BOTTOM;
    } else {
        const height = document.getElementById('place100wh')?.clientHeight ?? document.body.clientHeight;
        bottom = height - document.body.clientHeight;
    }
    return Math.max(bottom, DEFAULT_BOTTOM);
};

/**
 * 判断是否是ios需要在底部增加安全区的设备
 */
export const isIosSafeBottomDevice = (): boolean => browser.isIPadPro || browser.checkIsLargeThanIphoneX;

export default isIosSafeBottomDevice;
